import { APIError } from '../errors/APIError';
import { useAPIQuery } from '../useAPIProvider';

export const useRegions = () => {
  return useAPIQuery(['getRegions'], async client => {
    const response = await client.region.getRegions();
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body.items;
  });
};
